export default {
  setBlackLists(state, data) {
    state.blackLists = data;
  },

  setSaleManagerDiscountLimits(state, data) {
    state.saleManagerDiscountLimits = data;
  },

  setSaleManagerCredits(state, data) {
    state.saleManagerCredits = data;
  },

  setOrdrSettings(state, data) {
    state.ordrSettings = data || [];
  },

  setOrders(state, data) {
    state.orders = data;
  },
  setOrderById(state, data) {
    state.orderById = data;
  },
  setOrderMaxCode(state, data) {
    state.orderMaxCode = data;
  },

  setOrderCartable(state, data) {
    state.orderCartable = data;
  },

  setOrderManagementCartable(state, data) {
    state.orderManagementCartable = data;
  },

  setOrderPermitCartable(state, data) {
    state.orderPermitCartable = data;
  },
  setOrderPermits(state, data) {
    state.orderPermits = data;
  },
  setOrderDraftCartable(state, data) {
    state.orderDraftCartable = data;
  },
  setOrderDrafts(state, data) {
    state.orderDrafts = data;
  },

  setSettlementTypes(state, data) {
    state.settlementTypes = data;
  },
  setSettlementTypeCode(state, data) {
    state.settlementTypeCode = data;
  },

  setPrintLink(state, data) {
    state.printLink = data;
  },
};
